import React, { useState, useEffect } from 'react';
import { FRIEND_SEARCH_STATUS } from '../../constants';

const FriendSearchModal = ({ onClose, onSearchUsers, onAddFriend, friendRequests = [], onRespondRequest, onBlockUser, onReportSpam }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [addingId, setAddingId] = useState(null);
    const [reportingUser, setReportingUser] = useState(null);

    // Auto-search effect (Debounce)
    useEffect(() => {
        const timer = setTimeout(async () => {
            if (searchTerm.trim().length >= 3) {
                setIsSearching(true);
                const results = await onSearchUsers(searchTerm.trim());
                setSearchResults(results);
                setIsSearching(false);
            } else {
                setSearchResults([]);
            }
        }, 500); // รอ 500ms หลังหยุดพิมพ์ค่อยค้นหา
        return () => clearTimeout(timer);
    }, [searchTerm, onSearchUsers]);

    const handleAdd = async (user) => {
        setAddingId(user.id);
        try {
            await onAddFriend(user.username);
            // Update status locally
            setSearchResults(prev => prev.map(u => u.id === user.id ? { ...u, status: FRIEND_SEARCH_STATUS.REQUEST_SENT } : u));
        } catch (e) {
            // Error handled in parent
        } finally {
            setAddingId(null);
        }
    };

    return (
        <>
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'flex-end' }} onClick={onClose}>
            <div style={{ backgroundColor: '#fff', width: '100%', borderRadius: '20px 20px 0 0', padding: '20px', height: '90vh', overflowY: 'auto', animation: 'slideUp 0.3s ease-out' }} onClick={e => e.stopPropagation()}>
                <style>
                    {`@keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }`}
                </style>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0, fontSize: '18px', color: 'var(--color-text)' }}>เพิ่มเพื่อนใหม่</h3>
                    <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '24px', color: 'var(--color-text-subtle)', cursor: 'pointer' }}>&times;</button>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {/* Friend Requests Section */}
                    {friendRequests.length > 0 && (
                        <div style={{ marginBottom: '10px', backgroundColor: '#FFF3E0', padding: '15px', borderRadius: '12px', border: '1px solid #FFE0B2' }}>
                            <h4 style={{ margin: '0 0 10px 0', color: '#EF6C00', fontSize: '14px' }}>📩 คำขอเป็นเพื่อน ({friendRequests.length})</h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {friendRequests.map(req => (
                                    <div key={req.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#fff', padding: '8px', borderRadius: '8px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            {req.user.picture_url ? <img src={req.user.picture_url} alt="" style={{ width: '32px', height: '32px', borderRadius: '50%' }} /> : <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: 'var(--color-border)' }}></div>}
                                            <span style={{ fontWeight: 'bold', color: 'var(--color-text)', fontSize: '14px' }}>{req.user.display_name}</span>
                                        </div>
                                        <div style={{ display: 'flex', gap: '6px' }}>
                                            <button onClick={() => onRespondRequest(req.id, true)} style={{ padding: '4px 10px', backgroundColor: 'var(--color-primary)', backgroundImage: 'var(--color-primary-gradient)', color: 'white', border: 'none', borderRadius: '15px', fontSize: '12px', cursor: 'pointer' }}>รับ</button>
                                            <button onClick={() => onRespondRequest(req.id, false)} style={{ padding: '4px 10px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '15px', fontSize: '12px', cursor: 'pointer' }}>ไม่รับ</button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <input 
                        type="text" 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="ค้นหา Username (อย่างน้อย 3 ตัว)..." 
                        style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border)', fontSize: '16px', boxSizing: 'border-box' }}
                    />

                    {isSearching ? (
                        <div style={{ padding: '20px', textAlign: 'center', color: 'var(--color-text-subtle)' }}>กำลังค้นหา...</div>
                    ) : searchResults.length > 0 ? (
                        <div style={{ border: '1px solid var(--color-border)', borderRadius: '8px', overflow: 'hidden', marginTop: '10px' }}>
                            {searchResults.map(user => (
                                <div key={user.id} style={{ padding: '15px', borderBottom: '1px solid var(--color-surface-muted)', backgroundColor: '#fff', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    {user.picture_url ? <img src={user.picture_url} alt="" style={{ width: '40px', height: '40px', borderRadius: '50%' }} /> : <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--color-border)' }}></div>}
                                    <div style={{ flex: 1 }}>
                                        <div style={{ fontSize: '16px', fontWeight: 'bold', color: 'var(--color-text)' }}>{user.display_name}</div>
                                        <div style={{ fontSize: '14px', color: 'var(--color-text-subtle)' }}>@{user.username}</div>
                                    </div>
                                    {user.status === FRIEND_SEARCH_STATUS.ACCEPTED ? (
                                        <span style={{ fontSize: '12px', color: 'var(--color-primary)', fontWeight: 'bold', padding: '8px 16px' }}>เพื่อนแล้ว</span>
                                    ) : user.status === FRIEND_SEARCH_STATUS.REQUEST_SENT ? (
                                        <span style={{ fontSize: '12px', color: '#FF9800', fontWeight: 'bold', padding: '8px 16px' }}>รอตอบรับ</span>
                                    ) : user.status === FRIEND_SEARCH_STATUS.REQUEST_RECEIVED ? (
                                        <span style={{ fontSize: '12px', color: '#2196F3', fontWeight: 'bold', padding: '8px 16px' }}>รอคุณตอบรับ</span>
                                    ) : (
                                        <button 
                                            onClick={() => handleAdd(user)} 
                                            disabled={addingId === user.id}
                                            style={{ padding: '8px 16px', backgroundColor: 'var(--color-primary)', backgroundImage: 'var(--color-primary-gradient)', color: 'white', border: 'none', borderRadius: '20px', fontWeight: 'bold', cursor: 'pointer', opacity: addingId === user.id ? 0.7 : 1 }}
                                        >
                                            {addingId === user.id ? '...' : 'ส่งคำขอ'}
                                        </button>
                                    )}
                                    
                                    {/* Action Menu (Block/Report) */}
                                    <div style={{ display: 'flex', gap: '5px', marginLeft: '5px' }}>
                                        <button onClick={() => setReportingUser(user)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', padding: '4px' }} title="รายงานสแปม">
                                            🚩
                                        </button>
                                        <button onClick={() => onBlockUser && onBlockUser(user)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', padding: '4px' }} title="บล็อกผู้ใช้">
                                            🚫
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : searchTerm.length >= 3 ? (
                        <div style={{ padding: '20px', textAlign: 'center', color: 'var(--color-text-subtle)' }}>ไม่พบผู้ใช้</div>
                    ) : null}
                </div>
            </div>
        </div>

        {reportingUser && (
            <ReportSpamModal 
                user={reportingUser} 
                onClose={() => setReportingUser(null)} 
                onSubmit={(reason) => {
                    onReportSpam(reportingUser, reason);
                    setReportingUser(null);
                }} 
            />
        )}
        </>
    );
};

const ReportSpamModal = ({ user, onClose, onSubmit }) => {
    const [reason, setReason] = useState('');
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2100, display: 'flex', alignItems: 'flex-end' }} onClick={onClose}>
            <div style={{ backgroundColor: '#fff', width: '100%', borderRadius: '20px 20px 0 0', padding: '20px', height: 'auto', maxHeight: '80vh', paddingBottom: '40px', animation: 'slideUp 0.3s ease-out' }} onClick={e => e.stopPropagation()}>
                <h3 style={{ margin: '0 0 15px 0', color: 'var(--color-text)' }}>รายงาน {user.display_name}</h3>
                <p style={{ color: 'var(--color-text-muted)', fontSize: '14px', marginBottom: '15px' }}>โปรดระบุเหตุผลที่ต้องการรายงาน (เช่น สแปม, ก่อกวน, หรือเนื้อหาไม่เหมาะสม)</p>
                <textarea 
                    value={reason} 
                    onChange={(e) => setReason(e.target.value)} 
                    placeholder="ระบุเหตุผล..." 
                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border)', minHeight: '100px', fontSize: '16px', boxSizing: 'border-box', marginBottom: '20px', fontFamily: 'inherit' }}
                />
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={onClose} style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border)', backgroundColor: '#fff', color: 'var(--color-text-muted)', fontWeight: 'bold', cursor: 'pointer' }}>ยกเลิก</button>
                    <button onClick={() => onSubmit(reason)} style={{ flex: 1, padding: '12px', borderRadius: '8px', border: 'none', backgroundColor: '#f44336', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>ส่งรายงาน</button>
                </div>
            </div>
        </div>
    );
};

export default FriendSearchModal;
